/**
 * ljv-search-tracking.js
 *
 * Such-Tracking fuer die Header-Suche (Overlay) und die Suchergebnisseite.
 * Spezifikation: gleiche Event-Namen und Parameter in allen Shops.
 *
 * Events: search_open, search, search_no_results, select_item,
 *         search_suggestion_click (search_filter entfaellt: das Overlay hat keine Filter).
 * view_search_results kommt nativ (GA4 Enhanced Measurement) und wird hier nicht gesendet.
 *
 * Transport: IMMER Shopify.analytics.publish (Customer Events); zusaetzlich gtag('event'),
 * weil gtag im Theme (layout/theme.liquid) vorhanden ist. Kein eigenes GA4-Snippet, keine
 * Consent-Umgehung: gtag unterliegt dem Consent-Zustand, den GTM/Cookie-Banner setzen.
 * Keine personenbezogenen Daten; Suchbegriffe auf 100 Zeichen gekappt.
 */
(function () {
  'use strict';
  if (window.__ljvSearchTracking) return;
  window.__ljvSearchTracking = true;

  var IDLE_MS = 800;       // Eingabepause, nach der ein Begriff als "abgeschlossen" gilt
  var COUNT_WAIT_MS = 3000; // so lange warten wir auf die Trefferzahl der Vorschlagssuche
  var MIN_CHARS = 2;
  // Mess-ID aus layout/theme.liquid. Ohne send_to verwirft die Seite jedes gtag('event') mit
  // eigenem Namen (Theme-gtag, Google-Tag-Manager-Container und Google-&-YouTube-App teilen sich
  // dataLayer und Mess-ID): auf frisch geladenen Seiten erreichte kein Such-Event GA4.
  var GA_ID = 'G-0Y8D0PPRPE';

  var lastSent = '';
  var pending = null;      // { term, source }
  var idleTimer = null;
  var waitTimer = null;
  var meta = null;         // { term, products } der zuletzt gerenderten Vorschlagssuche

  function clean(term) {
    return String(term || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function norm(term) {
    return clean(term).toLowerCase();
  }

  function send(name, params) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* Tracking darf die Suche nie stoeren */ }
    try {
      if (typeof window.gtag === 'function') {
        var gp = { send_to: GA_ID };
        for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) gp[k] = params[k];
        window.gtag('event', name, gp);
      }
    } catch (e2) { /* siehe oben */ }
  }

  // ------------------------------------------------------------ Suchbegriffe

  function sendSearch(term, source, count) {
    term = clean(term);
    if (term.length < MIN_CHARS || norm(term) === norm(lastSent)) return;
    lastSent = term;
    var params = { search_term: term, search_source: source };
    if (typeof count === 'number') params.results_count = count;
    send('search', params);
    if (count === 0) send('search_no_results', { search_term: term, search_source: source });
  }

  function metaFor(term) {
    return meta && norm(meta.term) === norm(term) ? meta.products : null;
  }

  function clearTimers() {
    clearTimeout(idleTimer);
    clearTimeout(waitTimer);
  }

  /** Sendet den wartenden Begriff, sobald seine Trefferzahl bekannt ist. */
  function flush(force) {
    if (!pending) return;
    var count = metaFor(pending.term);
    if (count === null && !force) return;
    var p = pending;
    pending = null;
    clearTimeout(waitTimer);
    sendSearch(p.term, p.source, count === null ? undefined : count);
  }

  function onIdle(input) {
    var term = clean(input.value);
    if (term.length < MIN_CHARS || norm(term) === norm(lastSent)) { pending = null; return; }
    pending = { term: term, source: 'overlay' };
    flush(false);
    if (pending) {
      clearTimeout(waitTimer);
      waitTimer = setTimeout(function () { flush(true); }, COUNT_WAIT_MS);
    }
  }

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.header-search__input')) return;
    clearTimers();
    pending = null;
    idleTimer = setTimeout(function () { onIdle(input); }, IDLE_MS);
  }, true);

  // Enter / "Alle Ergebnisse": im Window-Capture, damit wir den Begriff lesen, BEVOR
  // ljv-search-precision.js ihn in Feldsyntax umschreibt.
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.id || form.id !== 'predictive-search-form') return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var term = clean(input.value);
    if (!term) return;
    clearTimers();
    pending = null;
    var count = metaFor(term);
    sendSearch(term, 'overlay', count === null ? undefined : count);
  }, true);

  // ---------------------------------------------------- Trefferzahl auslesen

  function readMeta(root) {
    var el = root.querySelector('[data-ljv-search-meta]');
    if (!el) return;
    var n = parseInt(el.getAttribute('data-products'), 10);
    meta = { term: el.getAttribute('data-term') || '', products: isNaN(n) ? 0 : n };
    flush(false);
  }

  function observeResults() {
    var host = document.getElementById('header-predictive-search');
    if (!host || host.__ljvObserved) return;
    host.__ljvObserved = true;
    new MutationObserver(function () { readMeta(host); }).observe(host, { childList: true, subtree: true });
  }

  // -------------------------------------------------------------- Suche offen

  function onOpen() {
    lastSent = '';
    pending = null;
    meta = null;
    clearTimers();
    send('search_open', { search_source: 'overlay' });
  }

  function bindOverlay() {
    var overlays = document.querySelectorAll('header-search');
    for (var i = 0; i < overlays.length; i++) {
      if (overlays[i].__ljvBound) continue;
      overlays[i].__ljvBound = true;
      overlays[i].addEventListener('dialog:after-show', onOpen);
    }
    observeResults();
  }

  // --------------------------------------------------------------- Klicks

  function psq(anchor) {
    try { return new URL(anchor.href, location.origin).searchParams.get('_psq') || ''; } catch (e) { return ''; }
  }

  function posOf(anchor) {
    try {
      var n = parseInt(new URL(anchor.href, location.origin).searchParams.get('_pos'), 10);
      return isNaN(n) ? 0 : n;
    } catch (e) { return 0; }
  }

  /** Begriff der Ergebnisseite: roher Begriff, nicht die umgeschriebene Feldsyntax. */
  function pageTerm() {
    var t = (window.ljvSearch && window.ljvSearch.terms) || new URLSearchParams(location.search).get('q') || '';
    if (t.indexOf('product_type:') !== -1) {
      var first = t.split(' OR ')[0] || '';
      var c = first.indexOf(':');
      t = c === -1 ? first : first.slice(c + 1);
    }
    return clean(t);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var anchor = target.closest('a[href]');
    if (!anchor) return;

    var overlay = anchor.closest('predictive-search');
    if (overlay) {
      var item = anchor.closest('[data-ljv-item-id]');
      var term = psq(anchor) || (meta && meta.term) || '';
      if (item) {
        send('select_item', {
          item_list_id: 'search',
          item_list_name: 'overlay',
          search_term: clean(term),
          index: parseInt(item.getAttribute('data-ljv-index'), 10) || posOf(anchor) || 1,
          items: [{ item_id: item.getAttribute('data-ljv-item-id'), item_name: item.getAttribute('data-ljv-item-name') }]
        });
      } else if (anchor.closest('.predictive-search__suggestions')) {
        send('search_suggestion_click', { search_term: clean(term), suggestion: clean(anchor.textContent), suggestion_type: 'query' });
      } else if (anchor.closest('.predictive-search__collections')) {
        send('search_suggestion_click', { search_term: clean(term), suggestion: clean(anchor.textContent), suggestion_type: 'collection' });
      }
      return;
    }

    // Ergebnisseite /search
    var card = anchor.closest('.main-search product-card[data-ljv-item-id]');
    if (card) {
      var cards = document.querySelectorAll('.main-search product-card[data-ljv-item-id]');
      var idx = posOf(anchor) || (Array.prototype.indexOf.call(cards, card) + 1);
      send('select_item', {
        item_list_id: 'search',
        item_list_name: 'page',
        search_term: psq(anchor) ? clean(psq(anchor)) : pageTerm(),
        index: idx,
        items: [{ item_id: card.getAttribute('data-ljv-item-id'), item_name: card.getAttribute('data-ljv-item-name') }]
      });
    }
  }, true);

  bindOverlay();
  document.addEventListener('DOMContentLoaded', bindOverlay);
})();
